import { noop } from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { useToast } from '~/eds/src/components/hooks/useToast';
import { Modal } from '~/eds/src/components/Modal/Modal';
import { Text } from '~/eds/src/components/Text/Text';
import { slices } from '~/redux/slices';
import { RoutePathType } from '~/routing/enums';
import { useRouting } from '~/routing/useRouting';

/**
 * A modal to redirect from other domains to creating Field AI models
 * @returns
 */
export const RedirectToXRayModal = () => {
  const { navigate } = useRouting();

  const dispatch = useDispatch();

  const redirect = useSelector(slices.xRay.selectors.selectRedirect);

  const { toast } = useToast();

  const intl = useIntl();

  const clearRedirect = () => dispatch(slices.xRay.actions.setRedirect(null));

  const primaryAction = {
    text: intl.formatMessage({
      id: 'RedirectToXRayModal.confirmButton',
      defaultMessage: 'Confirm',
      description: 'Confirm button text',
    }),
    onClick: () => {
      if (redirect) {
        dispatch(slices.xRay.actions.resetXRay());
        dispatch(slices.xRay.actions.setInstructions(redirect.instructions));
        navigate(`${RoutePathType.AutomationHubFields}/new`);
        clearRedirect();
        toast({
          status: 'info',
          title: intl.formatMessage({
            id: 'RedirectToXRayModal.toastTitle',
            defaultMessage:
              'Instructions for the model have been auto-populated',
            description: 'Toast title when instructions are auto-populated',
          }),
          message: intl.formatMessage({
            id: 'RedirectToXRayModal.toastMessage',
            defaultMessage: 'You can edit the instructions.',
            description: 'Toast message about editing instructions',
          }),
          onDismiss: noop,
        });
      }
    },
  };

  return (
    <Modal
      isVisible={redirect !== null}
      primaryAction={primaryAction}
      title={intl.formatMessage({
        id: 'RedirectToXRayModal.title',
        defaultMessage: 'Use This Question for a New Field Model',
        description: 'Modal title for redirecting to new field model creation',
      })}
      onCancel={clearRedirect}
    >
      <Text>
        <p>
          <FormattedMessage
            id="RedirectToXRayModal.confirmationQuestion"
            defaultMessage="Would you like to create a New Field Model based on the question selected?"
            description="Question asking user to confirm model creation"
          />
        </p>
        <p>
          <FormattedMessage
            id="RedirectToXRayModal.redirectDescription"
            defaultMessage="This action will take you to the place to create a New Field Model powered by AI based on the question you selected."
            description="Description of what happens when user confirms"
          />
        </p>
      </Text>
    </Modal>
  );
};
